export default class Ada {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.setupEventListeners();
    }
  }

  //===========================================================================
  // Any element with role="dropdown" or role="button"
  //===========================================================================

  roleInteract(e) {
    const $target = $(e.target);
    const role = $target[0].getAttribute('role');
    const keyD = e.key !== undefined ? e.key : e.keyCode;

    if ((keyD === 'Enter' || keyD === 13) || (['Spacebar', ' '].indexOf(keyD) >= 0 || keyD === 32)) {
      if (role === 'dropdown') {
        e.preventDefault();
        $target.toggleClass('active');
      } else if (role === 'button') {
        e.preventDefault();
        $target.click();
      }
    }
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(document).on('keydown', '[role="button"], [role="dropdown"]', this.roleInteract.bind(this));
  }
}
